import React, { useState } from 'react';
import { Button } from 'reactstrap';
import EnableAuthenticator from './EnableAuthenticator';
import RecoveryCodes from './RecoveryCodes';

interface EnableTotpAuthenticatorProps {
	setActivated: (active: boolean) => void;
	onFinished: () => void;
}

/**
 * Component that lets a user set up a TOTP authenticator app (like Google Authenticator)
 */
export default function EnableTotpAuthenticator(props: EnableTotpAuthenticatorProps) {
	const [showEnableAuthenticator, setShowEnableAuthenticator] = useState(false);
	const [showRecoveryCodes, setShowRecoveryCodes] = useState(false);
	const [showAddAuthenticator, setShowAddAuthenticator] = useState(true);

	return (
		<>
			{showAddAuthenticator ? (
				<>
					<Button
						data-testid="add-totp-authenticator-btn"
						color="primary"
						onClick={() => {
							props.setActivated(true);
							setShowAddAuthenticator(false);
							setShowEnableAuthenticator(true);
						}}
					>
						Add authenticator app
					</Button>{' '}
				</>
			) : null}
			{showEnableAuthenticator ? (
				<EnableAuthenticator
					onCancelClick={() => {
						props.setActivated(false);
						setShowEnableAuthenticator(false);
						setShowAddAuthenticator(true);
					}}
					afterSubmit={(generateCodes) => {
						if (generateCodes) {
							setShowEnableAuthenticator(false);
							setShowRecoveryCodes(true);
						} else {
							props.onFinished();
						}
					}}
				/>
			) : null}
			{showRecoveryCodes ? <RecoveryCodes onCancelClick={props.onFinished} generate={true} /> : null}
		</>
	);
}
